/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CKEditor } from "ckeditor4-react";
import produce from "immer";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";
import { Button, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { FileUploader } from "../../../components/FileUploader/FileUploader";
import { IInvestigator } from "../../../interfaces/IInvestigator";
import { paths } from "../../../utils/paths";
import Axios from "axios";
import {
  create,
  Delete,
  getAll,
  getById,
  getByInvestigator,
  resetPass,
  saveFile,
  update,
} from "../../../utils/requests/dynamicReq";
import { validateEmail } from "../../../utils/validate";
import { ROUTES } from "../../../utils/routes";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo, faSearch, faTrash } from "@fortawesome/free-solid-svg-icons";
import { IPublication } from "../../../interfaces/IPublication";
import estrella from "../../../assets/images/estrella.svg";
import estrellaAzul from "../../../assets/images/estrellaSolid.svg";
import {
  requiredInputs,
  SwalError,
  editorConfig,
  baseURL,
} from "../../../utils/constants";
import moment from "moment";
import parse from "html-react-parser";
import { CvaUploader } from "../../../components/FileUploader/CvaUploader";
import { PdfUploader } from "../../../components/FileUploader/PdfUploader";
import { ArchiveUploader } from "../../../components/FileUploader/ArchiveUploader";

interface IAmbitoShort {
  ambito_id: string;
  tituloEs: string;
}

interface IInvestigatorRole {
  staff_role_id: string;
  name: string;
}

interface IUserRole {
  user_role_id: string;
  name: string;
}

interface INewPassword {
  oldPassword: string;
  newPassword: string;
}

interface INewUser {
  username: string;
  ownerId: number;
  userRoleId: number;
  userType: string;
}

export const ManageProfile: FC = () => {
  let { token, staffId, isAdmin } = useSelector(
    ({ user }: IStore) => user as IUser
  );
  const history = useHistory();

  const { pathname }: any = useLocation();
  let id: any = "";
  if (pathname.includes("perfil")) {
    id = staffId?.toString()!;
  } else {
    id = pathname.split("/")[2];
  }
  let userType: string = "";
  if (pathname.includes("service")) {
    userType = "service-staff";
  } else {
    userType = "investigator";
  }

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const {
    INVESTIGATORS,
    AMBITOS,
    INVESTROLE,
    USERROLE,
    USERS,
    newUsers,
    userSelectPUBLICATION,
    publicationsINVESTIGATOR,
    NEWPASSWORD,
    RESETPASSWORD,
  } = paths;

  const [isCreate, setIsCreate] = useState(false);
  const [isMyProfile, setIsMyProfile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  //userForm
  const [userToEditId, setUserToEditId] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");

  const [userName, setUserName] = useState("");
  const [email_personal, setEmail] = useState("");
  const [image, setImage] = useState();
  const [telefono, setTelefono] = useState("");
  const [ambitos, setAmbitos] = useState<IAmbitoShort[]>([]);
  const [chosenAmbitos, setChosenAmbitos] = useState([]);
  const [cv, setCv] = useState("");
  const [archivoDocumento, setArchivoDocumento] = useState("");
  const [emailPublico, setEmailPublico] = useState("");
  const [doctorando, setDoctorando] = useState("");
  const [aparecerTodos, setAparecerTodos] = useState("");
  const [userRoles, setUserRoles] = useState<IUserRole[]>([]);
  const [staffRole, setStaffRole] = useState("");
  const [grupoFuncional, setGrupoFuncional] = useState("");
  const [chosenUserRoleId, setChosenUserRoleId] = useState("");
  const [investigatorTypes, setInvestigatorTypes] = useState<
    IInvestigatorRole[]
  >([]);
  const [fechaNacimiento, setFechaNacimiento] = useState(new Date());
  const [chosenUserTypeId, setChosenUserTypeId] = useState("");
  const [facebook, setFacebook] = useState("");
  const [orcid, setOrcid] = useState("");
  const [skype, setSkype] = useState("");
  const [lugarNacimiento, setLugarNacimiento] = useState("");
  const [numeroSeguroSocial, setNumeroSeguroSocial] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [documentoDeIdentidad, setDocumentoDeIdentidad] = useState("");
  const [direccionPostalPersonal, setDireccionPostalPersonal] = useState("");
  const [twitter, setTwitter] = useState("");
  const [linkedIn, setLinkedIn] = useState("");
  const [blueSky, setBlueSky] = useState("");
  const [bioEs, setBioEs] = useState("");
  const [bioEn, setBioEn] = useState("");
  const [bioVa, setBioVa] = useState("");
  const [tituloEs, setTituloEs] = useState("");
  const [tituloEn, setTituloEn] = useState("");
  const [tituloVa, setTituloVa] = useState("");
  const [contratos, setContratos] = useState<
    { name: string; archivo: string }[]
  >([]);
  const [titulos, setTitulos] = useState<{ name: string; archivo: string }[]>(
    []
  );

  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [selectedPublications, setSelectedPublications] = useState<
    IPublication[]
  >([]);
  const [displayPublications, setDisplayPublications] = useState<
    IPublication[]
  >([]);

  //change Password
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatNewPass, setRepeatNewPass] = useState("");
  const [isPassChecked, setIsPassChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [passMessage, setPassMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);

  useEffect(() => {
    isMountedRef.current = true;
    checkIfCreate();
    loadAmbitos();
    loadInvestigationRoles();
    loadUserRole();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const checkIfCreate = () => {
    const { pathname }: any = history.location;
    if (pathname.includes("crear")) {
      setIsCreate(true);
    } else {
      loadInvestigator();
      if (pathname.includes("perfil")) {
        setIsLoading(true);
        setIsMyProfile(true);
        loadUserPublications();
      }
    }
  };

  const loadAmbitos = async () => {
    try {
      let rawInvGroups = await getAll(AMBITOS, source);

      if (isMountedRef.current) {
        filterGruops(rawInvGroups);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
      console.log(error);
    }
  };

  const filterGruops = (rawGroups: any[]) => {
    let filteredGropus: IAmbitoShort[] = rawGroups.map(({ id, tituloEs }) => ({
      ambito_id: id,
      tituloEs: tituloEs,
    }));
    setAmbitos(filteredGropus);
  };

  const loadInvestigationRoles = async () => {
    try {
      let roles = await getAll(INVESTROLE, source);

      if (isMountedRef.current) {
        filterInvestigatorRole(roles);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
      console.log(error);
    }
  };

  const filterInvestigatorRole = (roles: any[]) => {
    let filteredInvestigatorRoles: IInvestigatorRole[] = roles.map(
      ({ id, name }) => ({
        staff_role_id: id,
        name,
      })
    );
    setInvestigatorTypes(filteredInvestigatorRoles);
  };

  const loadUserPublications = async () => {
    let publications = await getByInvestigator(
      publicationsINVESTIGATOR,
      staffId,
      source
    );
    // setPublications(publications);
    reorderPublications(publications);
    setIsLoading(false);
  };

  const chechEmail = (value: string) => {
    let validatedEmail = validateEmail(value);
    if (!validatedEmail) {
      setMessage("Formato de email no válido.");
    } else {
      setMessage("");
    }
  };

  //HANDLE PUBLICATIONS

  const reorderPublications = (publications: any[]) => {
    let newPublications: any[] = [];
    publications.map(
      ({
        id,
        title,
        date,
        journal,
        url,
        authors,
        volPag,
        staffId,
        staffPublications,
      }: // eslint-disable-next-line array-callback-return
      any) => {
        newPublications.push({
          id,
          title,
          date,
          journal,
          url,
          authors,
          volPag,
          staffId,
          selected: staffPublications[0]?.selected,
        });
      }
    );
    return filterSelectedPublications(newPublications);
  };

  const filterSelectedPublications = (publications: IPublication[]) => {
    const selectedPublications = publications.filter(
      ({ selected }: IPublication) => selected === true
    );
    setSelectedPublications(selectedPublications);
    const displayPublications = publications.filter(
      ({ selected }: IPublication) => selected === false
    );
    setDisplayPublications(displayPublications);
  };

  const createOREditInvestigatorForm = () => {
    // Filtramos los contratos para incluir solo aquellos que tengan un archivo válido
    const filteredContratos = contratos.filter(
      (contrato) => contrato.archivo && Object.keys(contrato.archivo).length > 0
    );
    const filteredTitulos = titulos.filter(
      (titulo) => titulo.archivo && Object.keys(titulo.archivo).length > 0
    );

    let form: IInvestigator = isCreate
      ? {
          nombre,
          apellidos,
          email_personal,
          telefono,
          bioEs,
          bioEn,
          bioVa,
          tituloEs,
          tituloEn,
          tituloVa,
          ambitoIds: chosenAmbitos.map((ambito: any) => ambito.id),

          investigatorRoleId:
            staffRole === "investigation"
              ? +chosenUserTypeId
                ? +chosenUserTypeId
                : null
              : null,
          staffRole,
          grupoFuncional,
          fechaNacimiento: moment(fechaNacimiento).format("YYYY-MM-DD"),
          linkedin: linkedIn,
          blueSky,
          twitter,
          facebook,
          orcid,
          skype,
          lugarNacimiento,
          numeroSeguroSocial,
          documentoDeIdentidad,
          tipoDocumento,
          direccionPostalPersonal,
          username: userName,
          password,
          userRoleId: +chosenUserRoleId,
          emailPublico: emailPublico === "1" ? true : false,
          doctorando: doctorando === "1" ? true : false,
          aparecerTodos: aparecerTodos === "1" ? true : false,
          contratos: filteredContratos, // Solo se pasan los contratos válidos
          titulos: filteredTitulos,
        }
      : {
          nombre,
          apellidos,
          email_personal,
          telefono,
          bioEs,
          bioEn,
          bioVa,
          tituloEs,
          tituloEn,
          tituloVa,
          ambitoIds: chosenAmbitos.map((ambito: any) => ambito.id),

          investigatorRoleId:
            staffRole === "investigation"
              ? +chosenUserTypeId
                ? +chosenUserTypeId
                : null
              : null,
          staffRole,
          grupoFuncional,
          fechaNacimiento: moment(fechaNacimiento).format("YYYY-MM-DD"),
          linkedin: linkedIn,
          blueSky,
          twitter,
          facebook,
          orcid,
          skype,
          lugarNacimiento,
          numeroSeguroSocial,
          documentoDeIdentidad,
          tipoDocumento,
          direccionPostalPersonal,
          emailPublico: emailPublico === "1" ? 1 : 0,
          doctorando: doctorando === "1" ? 1 : 0,
          aparecerTodos: aparecerTodos === "1" ? 1 : 0,
          contratos: filteredContratos, // Solo se pasan los contratos válidos
          titulos: filteredTitulos,
        };

    return form;
  };

  const editUserForm = (ownerId: number) => {
    let userForm: INewUser = {
      username: userName,
      ownerId,
      userType,
      userRoleId: +chosenUserRoleId,
    };
    return userForm;
  };

  const handleSubmit = () => {
    let question: string = "";
    isCreate
      ? (question = `¿Quieres crear un nuevo usuario?`)
      : (question = " ¿Quieres actualizar tu perfil?");
    Swal.fire({
      icon: "question",
      text: question,
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "No",
      customClass: {
        confirmButton: "buttonSwalConfirm",
      },
    }).then(({ isConfirmed }) => {
      if (isConfirmed && isCreate) {
        handleNewUser();
      } else if (isConfirmed && !isCreate) {
        handleConfirmation();
      }
    });
  };

  const loadUserRole = async () => {
    try {
      let roles = await getAll(USERROLE, source);

      if (isMountedRef.current) {
        filterUserRole(roles);
      } else setAllowedEdit(true);
    } catch (error) {
      console.log("HTTP call cancelled");
      console.log(error);
    }
  };

  const filterUserRole = (roles: any[]) => {
    let filteredUserRoles: IUserRole[] = roles.map(({ id, name }) => ({
      user_role_id: id,
      name,
    }));
    setUserRoles(filteredUserRoles);
  };

  const checkPassword = (value: string) => {
    let repeatPassword = value;
    if (password !== repeatPassword) {
      setMessage("Las contraseñas no coinciden.");
    } else {
      setMessage("");
    }
  };

 const handleNewUser = () => {
   if (
     !nombre ||
     !apellidos ||
     !userName ||
     !email_personal ||
     !grupoFuncional ||
     !staffRole ||
     !chosenUserRoleId ||
     !password
   ) {
     Swal.fire({
       icon: "error",
       text: "Los campos con * son obligatorios. Por favor, completa el formulario.",
       customClass: {
         cancelButton: "buttonClass",
       },
     });
     return;
   }

   // Mostrar modal de carga
   Swal.fire({
     title: "Creando usuario...",
     text: "Por favor espera mientras se completan los pasos.",
     allowOutsideClick: false,
     didOpen: () => {
       Swal.showLoading();
     },
   });

   const form = createOREditInvestigatorForm();

   create(newUsers, form, source)
     .then(async (userCreated) => {
       const newlyCreatedStaffId = userCreated?.staff?.id;

       // Subida de imagen
       if (typeof image !== "string") {
         const formData = new FormData();
         formData.append("image", image!);
         await saveFile(
           INVESTIGATORS,
           newlyCreatedStaffId,
           "image",
           formData,
           source
         );
       }

       // Subida de CV
       if (typeof cv !== "string") {
         const formData = new FormData();
         formData.append("pdf", cv!);
         await saveFile(
           INVESTIGATORS,
           newlyCreatedStaffId,
           "cv",
           formData,
           source
         );
       }

       // Subida de documento adicional
       if (typeof archivoDocumento !== "string") {
         const formData = new FormData();
         formData.append("pdf", archivoDocumento!);
         await saveFile(
           INVESTIGATORS,
           newlyCreatedStaffId,
           "archivoDocumento",
           formData,
           source
         );
       }

       // Subida de contratos
       if (Array.isArray(contratos)) {
         for (const contrato of contratos) {
           if (typeof contrato.archivo !== "string") {
             const formData = new FormData();
             formData.append("contratos", contrato.archivo);
             formData.append("name", contrato.name);
             await saveFile(
               INVESTIGATORS,
               newlyCreatedStaffId,
               "contratos",
               formData,
               source
             );
           }
         }
       }

       // Subida de títulos
       if (Array.isArray(titulos)) {
         for (const titulo of titulos) {
           if (typeof titulo.archivo !== "string") {
             const formData = new FormData();
             formData.append("titulos", titulo.archivo);
             formData.append("name", titulo.name);
             await saveFile(
               INVESTIGATORS,
               newlyCreatedStaffId,
               "titulos",
               formData,
               source
             );
           }
         }
       }

       // Cerrar el modal de carga y mostrar éxito
       Swal.close();
       Swal.fire({
         icon: "success",
         text: "Usuario creado correctamente.",
       });
     })
     .catch((error) => {
       console.error(error);
       Swal.close();
       Swal.fire({
         icon: "error",
         text: "Ha habido un error, por favor intente de nuevo más tarde.",
       });
     });
 };


  // EDIT MY PROFILE
  const loadInvestigator = async () => {
    try {
      let allAmbitos = await getAll(AMBITOS, source);
      const {
        nombre,
        apellidos,
        email_personal,
        telefono,
        bioEs,
        bioEn,
        bioVa,
        tituloEs,
        tituloEn,
        tituloVa,
        ambitos,
        investigatorRole,
        staffRole,
        grupoFuncional,
        fechaNacimiento,
        linkedin,
        blueSky,
        twitter,
        facebook,
        orcid,
        skype,
        lugarNacimiento,
        numeroSeguroSocial,
        documentoDeIdentidad,
        tipoDocumento,
        direccionPostalPersonal,
        image,
        cv,
        archivoDocumento,
        emailPublico,
        doctorando,
        aparecerTodos,
        user,
        contratos,
        titulos,
      } = await getById(INVESTIGATORS, id, source);
      let a = await getById(INVESTIGATORS, id, source);
      const dateWithOffset = new Date(fechaNacimiento);
      const dateNoOffset = new Date(
        dateWithOffset.getTime() - dateWithOffset.getTimezoneOffset() * -60000
      );

      if (isMountedRef.current) {
        setNombre(nombre);
        setApellidos(apellidos);
        setEmail(email_personal);
        setTelefono(telefono);
        setBioEs(bioEs);
        setBioEn(bioEn);
        setBioVa(bioVa);
        setTituloEs(tituloEs);
        setTituloEn(tituloEn);
        setTituloVa(tituloVa);
       const selectedAmbitoIds = ambitos.map((a: any) => a.id);
       const availableAmbitos = allAmbitos.filter(
         (a: any) => !selectedAmbitoIds.includes(a.id)
       );

       setAmbitos(availableAmbitos);
       setChosenAmbitos(ambitos);
        setChosenUserTypeId(investigatorRole?.id);
        // setChosenAreaId(area?.id);
        setLinkedIn(linkedin);
        setBlueSky(blueSky);
        setTwitter(twitter);
        setFacebook(facebook);
        setOrcid(orcid);
        setSkype(skype);
        setLugarNacimiento(lugarNacimiento);
        setFechaNacimiento(dateNoOffset);
        setNumeroSeguroSocial(numeroSeguroSocial);
        setDocumentoDeIdentidad(documentoDeIdentidad);
        setTipoDocumento(tipoDocumento);
        setDireccionPostalPersonal(direccionPostalPersonal);
        setStaffRole(staffRole);
        setGrupoFuncional(grupoFuncional);
        setImage(image);
        setCv(cv);
        setArchivoDocumento(archivoDocumento);
        setEmailPublico(emailPublico === true ? "1" : "0");
        setDoctorando(doctorando === true ? "1" : "0");
        setAparecerTodos(aparecerTodos === true ? "1" : "0");
        setUserName(user?.username);
        setUserToEditId(user?.id);
        setChosenUserRoleId(user?.userRole?.id);
        setContratos(Array.isArray(contratos) ? contratos : []);
        setTitulos(Array.isArray(titulos) ? titulos : []);
        setAllowedEdit(true);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
      console.log(error);
    }
  };
  const handleAddContrato = () => {
    setContratos((prevContratos) => [
      ...(Array.isArray(prevContratos) ? prevContratos : []),
      { name: "", archivo: "" }, // Aseguramos el mismo tipo de datos
    ]);
  };

  const handleRemoveContrato = (index: any) => {
    setContratos(contratos.filter((_, i) => i !== index));
  };

  const handleAddTitulo = () => {
    setTitulos((prevTitulos) => [
      ...(Array.isArray(prevTitulos) ? prevTitulos : []),
      { name: "", archivo: "" }, // Aseguramos el mismo tipo de datos
    ]);
  };
const addItem = (item: string, type: string) => {
  const parsedItem: IAmbitoShort = JSON.parse(item);

  if (type === "ambitos") {
    setChosenAmbitos((state) =>
      produce(state, (draftState: IAmbitoShort[]) => {
        if (draftState.length < 2) {
          // ✅ Solo permite agregar si hay menos de 2 ámbitos
          draftState.push(parsedItem);

          // Quitar el ámbito seleccionado de la lista de opciones
          // setAmbitos((state) =>
          //   produce(state, (draftState: IAmbitoShort[]) => {
          //     const index = draftState.findIndex(
          //       ({ ambito_id }) => ambito_id === parsedItem.ambito_id
          //     );
          //     if (index !== -1) {
          //       draftState.splice(index, 1);
          //     }
          //   })
          // );
        } else {
          alert("Solo puedes seleccionar un máximo de 2 ámbitos."); // ✅ Muestra alerta si intenta agregar más de 2
        }
      })
    );
  }
};


  const removeItem = (item: any, type: any) => {
    if (!allowedEdit) return;

    if (type === "ambitos") {
      setChosenAmbitos((state) =>
        produce(state, (draftState) => {
          const index = draftState.findIndex(
            ({ ambito_id }) => ambito_id === item.ambito_id
          );
          if (index !== -1) {
            draftState.splice(index, 1); // ✅ Solo elimina el ámbito seleccionado
          }
        })
      );

      setAmbitos((state) =>
        produce(state, (draftState) => {
          if (
            !draftState.some(({ ambito_id }) => ambito_id === item.ambito_id)
          ) {
            draftState.push(item); // ✅ Solo lo agrega si no está en la lista de ámbitos
          }
        })
      );
    }
  };


  const handleRemoveTitulo = (index: any) => {
    setTitulos(titulos.filter((_, i) => i !== index));
  };

  const handleConfirmation = async () => {
    if (!nombre || !apellidos || !userName) {
      Swal.fire({
        icon: "error",
        text: "Los campos con * son obligatorios. Por favor, completa el formulario.",
        customClass: {
          cancelButton: "buttonClass",
        },
      });
      return;
    }

    // Mostrar modal de carga
    Swal.fire({
      title: "Actualizando perfil...",
      text: "Por favor espera mientras se completan los pasos.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const form = createOREditInvestigatorForm();
      await update(INVESTIGATORS, id, form, token);

      const userForm = editUserForm(+id);
      await update(USERS, +userToEditId, userForm, token);

      // Subida de imagen
      if (typeof image !== "string") {
        const formData = new FormData();
        formData.append("image", image!);
        await saveFile(INVESTIGATORS, id, "image", formData, source);
      }

      // Subida de CV
      if (typeof cv !== "string") {
        const formData = new FormData();
        formData.append("pdf", cv!);
        await saveFile(INVESTIGATORS, id, "cv", formData, source);
      }

      // Subida de documento adicional
      if (typeof archivoDocumento !== "string") {
        const formData = new FormData();
        formData.append("pdf", archivoDocumento);
        await saveFile(INVESTIGATORS, id, "archivoDocumento", formData, source);
      }

      // Subida de contratos
      if (Array.isArray(contratos)) {
        for (const contrato of contratos) {
          if (typeof contrato.archivo !== "string") {
            const formData = new FormData();
            formData.append("contratos", contrato.archivo);
            formData.append("name", contrato.name);
            await saveFile(INVESTIGATORS, id, "contratos", formData, source);
          }
        }
      }

      // Subida de títulos
      if (Array.isArray(titulos)) {
        for (const titulo of titulos) {
          if (typeof titulo.archivo !== "string") {
            const formData = new FormData();
            formData.append("titulos", titulo.archivo);
            formData.append("name", titulo.name);
            await saveFile(INVESTIGATORS, id, "titulos", formData, source);
          }
        }
      }

      // Cerrar el modal de carga y mostrar éxito
      Swal.close();
      Swal.fire({
        icon: "success",
        text: "Perfil actualizado correctamente.",
      });
    } catch (error) {
      console.error(error);
      Swal.close();
      Swal.fire({
        icon: "error",
        text: "Ha habido un error, por favor intente de nuevo más tarde.",
      });
    }
  };


  const handleDelete = () => {
    Swal.fire({
      icon: "question",
      text: `¿Quieres borrar este usuario?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed &&
        Delete(INVESTIGATORS, id, source)
          .then(({ id }) => {
            Swal.fire({
              icon: "success",
              text: `Usuario borrado correctamente.`,
            });
            history.push(ROUTES.Users.all);
            setIsCreate(false);
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              icon: "error",
              text: "Ha habido un error, por favor intente de nuevo más tarde.",
            });
          });
    });
  };

  const editDeleteButtons = () => {
    if (!isCreate && !isMyProfile) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-success ml-1"
            onClick={handleResetPassword}
          >
            <FontAwesomeIcon icon={faRedo} />
          </button>
          <button className="smallBtn btn-danger ml-1" onClick={handleDelete}>
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    } else if (!isCreate && isMyProfile) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
        </>
      );
    } else {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Usuario
        </button>
      );
    }
  };

  //PUBLICATIONS

  const searchBar = (value: any) => {
    setDisplayPublications(
      displayPublications.filter(({ title }: any) =>
        title.toLowerCase().includes(value.toLowerCase())
      )
    );
    !value && setDisplayPublications(displayPublications);
  };

  const changeIcon = (isSelected: any) => {
    return !isSelected ? estrella : estrellaAzul;
  };

  const changeNotSelected = (index: number) => {
    if (displayPublications[index!].selected === false) {
      const newdisplayPublications = [...displayPublications];
      newdisplayPublications[index!].selected = true;
      setDisplayPublications(newdisplayPublications);
      setTimeout(() => {
        handleSubmitPublications();
      }, 200);
    } else if (displayPublications[index!].selected === true) {
      const newdisplayPublications = [...displayPublications];
      newdisplayPublications[index!].selected = false;
      setDisplayPublications(newdisplayPublications);
      setTimeout(() => {
        handleSubmitPublications();
      }, 200);
    }
  };

  const changeSelected = (index: number) => {
    if (selectedPublications[index!].selected === false) {
      const newSelectedPublications = [...selectedPublications];
      newSelectedPublications[index!].selected = true;
      setSelectedPublications(newSelectedPublications);
      setTimeout(() => {
        handleSubmitPublications();
      }, 200);
    } else if (selectedPublications[index!].selected === true) {
      const newSelectedPublications = [...selectedPublications];
      newSelectedPublications[index!].selected = false;
      setSelectedPublications(newSelectedPublications);
      setTimeout(() => {
        handleSubmitPublications();
      }, 200);
    }
  };

  //HANDLE SELECTED PUBLICATIONS

  const handleSubmitPublications = () => {
    const newPublications = buildSelectedPublications();
    const count = countSelected(newPublications);
    if (count > 5) {
      Swal.fire({
        icon: "error",
        text: "Se pueden seleccionar un máximo de 5 publicaciones",
        customClass: {
          cancelButton: "buttonClass",
        },
      });
    } else {
      create(
        `${userSelectPUBLICATION}/${id}/publication/`,
        newPublications,
        source
      )
        .then(() => {
          Swal.fire({
            icon: "success",
            text: `Publicaciones seleccionadas correctamente.`,
          });
          loadUserPublications();
          isMountedRef.current && setIsCreate(false);
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            text: SwalError,
          });
        });
    }
  };

  const buildSelectedPublications = () => {
    let newSelectedPublications: any[] = [];
    let completePublications = [
      ...selectedPublications,
      ...displayPublications,
    ];
    completePublications.map(({ id: publicationId, selected }: any) =>
      newSelectedPublications.push({
        staffId,
        publicationId,
        selected,
      })
    );
    return newSelectedPublications;
  };

  const countSelected = (totalPublications: any[]) => {
    const count = totalPublications.filter(
      ({ selected }) => selected === true
    ).length;
    return count;
  };

  //CHANGE PASSWORD

  const checkNewPassword = (value: string) => {
    let repeatNewPass = value;
    if (newPassword !== repeatNewPass) {
      setPassMessage("Las contraseñas no coinciden.");
      setIsPassChecked(false);
    } else {
      setPassMessage("");
      setIsPassChecked(true);
    }
  };

  //HANDLE CAHNGE PASSWORD

  const handleSubmitNewPassword = () => {
    if (!oldPassword || !newPassword || !repeatNewPass) {
      setPassMessage(requiredInputs);
      setTimeout(() => setPassMessage(""), 4000);
      return;
    }
    const newPasswordForm: INewPassword = {
      oldPassword,
      newPassword,
    };
    Swal.fire({
      icon: "question",
      text: `¿Quieres cambiar tu contraseña?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed && handleNewPasswordConfirmation(newPasswordForm);
    });
  };

  const handleNewPasswordConfirmation = (newPasswordForm: INewPassword) => {
    create(NEWPASSWORD, newPasswordForm, source)
      .then(() => {
        Swal.fire({
          icon: "success",
          text: `Contraseña cambiada correctamente.`,
        });
        isMountedRef.current && setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  //HANDLE RESET PASSWORD

  const handleResetPassword = () => {
    Swal.fire({
      icon: "question",
      text: `¿Quieres resetear la contraseña de este usuario?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed &&
        resetPass(RESETPASSWORD, +userToEditId, source)
          .then(() => {
            const year = moment(new Date()).locale("es").format("YYYY");
            Swal.fire({
              icon: "success",
              text: `Contraseña reseteada a ingenio${year}`,
            });
            isMountedRef.current && setIsCreate(false);
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              text: SwalError,
            });
          });
    });
  };

  return (
    <div className="centerPage">
      <div className="container-fluid ">
        <div className="row">
          <div className="col d-flex justify-content-between">
            <div>
              <h3>Perfil</h3>
            </div>
            <div>{editDeleteButtons()}</div>
          </div>
        </div>
      </div>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-4">
        <div className="form-row mt-2  d-flex flex-start">
          {!isCreate ? (
            <div style={{ width: "50%", paddingLeft: "10%" }}>
              <FileUploader handleFile={setImage} image={image} />
            </div>
          ) : (
            <div style={{ width: "50%", paddingLeft: "10%" }}>
              <FileUploader handleFile={setImage} image={image} />
            </div>
          )}

          <div className="col-6   justify-content-center">
            <small id="label">Nombre*</small>
            <input
              type="text"
              className="form-control"
              // placeholder="Nombre"
              value={nombre}
              onChange={({ target: { value } }) => {
                setNombre(value);
              }}
            />
            <div className=" mt-2">
              {" "}
              <small>Apellidos*</small>
              <input
                type="text"
                className="form-control"
                // placeholder="Primer Apellido"
                value={apellidos}
                onChange={({ target: { value } }) => {
                  setApellidos(value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="form-row mt-3">
          <h5>Datos de usuario</h5>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>Nombre de Usuario*</small>
            <input
              type="text"
              className="form-control"
              // placeholder="Nombre de usuario"
              value={userName}
              onChange={({ target: { value } }) => {
                setUserName(value);
              }}
            />
          </div>
          <div className="col">
            <small>Email*</small>
            <input
              type="text"
              className="form-control"
              // placeholder="Email"
              value={email_personal}
              onChange={({ target: { value } }) => {
                setEmail(value);
                chechEmail(value);
              }}
            />
          </div>
          <div className="col">
            <span>Email público?</span>
            <select
              className="form-control input"
              value={emailPublico}
              onChange={({ target: { value } }) => {
                setEmailPublico(value);
              }}
            >
              <option value={0}>Email oculto</option>
              <option value={1}>Email público</option>
            </select>
          </div>

          <div className="col">
            <small>Teléfono</small>
            <input
              type="text"
              className="form-control"
              // placeholder="Teléfono"
              value={telefono ? telefono : ""}
              onChange={({ target: { value } }) => {
                setTelefono(value);
              }}
            />
          </div>
        </div>

        {isCreate && (
          <div className="form-row">
            <div className="col">
              <small id="label">Contraseña*</small>
              <input
                type="password"
                className="form-control"
                // placeholder="Contraseña"
                disabled={!isCreate}
                value={password}
                onChange={({ target: { value } }) => {
                  setPassword(value);
                }}
              />
            </div>
            <div className="col">
              <small>Repetir contraseña*</small>
              <input
                type="password"
                className="form-control"
                // placeholder="Repetir contraseña"
                disabled={!isCreate}
                value={repeatPassword}
                onChange={({ target: { value } }) => {
                  setRepeatPassword(value);
                  checkPassword(value);
                }}
              />
            </div>
          </div>
        )}

        {(isCreate || isAdmin) && (
          <div className="form-row mt-3">
            <div className="col">
              <small>Categoría de usuario*</small>
              <select
                className="form-control input"
                value={staffRole}
                onChange={({ target: { value } }) => {
                  setStaffRole(value);
                }}
              >
                <option value="">Categoría de usuario</option>
                <option value="administration">Administración</option>
                <option value="technical">Técnico</option>{" "}
                <option value="investigation">Investigación</option>
              </select>
            </div>
            <div className="col">
              <small>Grupo funcional*</small>
              <select
                className="form-control input"
                value={grupoFuncional}
                onChange={({ target: { value } }) => {
                  setGrupoFuncional(value);
                }}
              >
                <option value="leadership">Equipo directivo</option>
                <option value="research_staff">
                  Personal investigador
                </option>{" "}
                <option value="doctoral_researcher">
                  Investigadores pre-doctorales
                </option>
                <option value="management">Gestion y apoyo tecnico</option>
              </select>
            </div>

            <div className="col">
              <small>Rol de usuario*</small>
              <select
                className="form-control input"
                value={chosenUserRoleId}
                onChange={({ target: { value } }) => {
                  setChosenUserRoleId(value);
                }}
              >
                <option>Rol de usuario</option>
                {userRoles?.map(({ user_role_id, name }) => (
                  <option key={user_role_id} value={user_role_id}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div className="form-row mt-4">
          <div className="col">
            <span>Ámbitos</span>
            <select
              className="form-control input"
              value={""}
              onChange={({ target }: any) => addItem(target.value, "ambitos")}
              disabled={!allowedEdit}
            >
              <option value={""}>Seleccionar Ámbito</option>
              {ambitos?.map((ambit: any) => (
                <option key={ambit.ambito_id} value={JSON.stringify(ambit)}>
                  {ambit.tituloEs}
                </option>
              ))}
            </select>
            {chosenAmbitos?.map((ambit: any) => (
              <span
                key={ambit.ambito_id}
                style={{ cursor: "pointer" }}
                className="badge badge-info badge-blue-color mr-1 mt-3"
                onClick={() => removeItem(ambit, "ambitos")}
              >
                {ambit.tituloEs} X
              </span>
            ))}
          </div>

          <div className="col">
            <span>Doctorando?</span>
            <select
              className="form-control input"
              value={doctorando}
              onChange={({ target: { value } }) => {
                setDoctorando(value);
              }}
            >
              <option value={0}>No</option>
              <option value={1}>Si</option>
            </select>
          </div>
          <div className="col">
            <span>Aparecer en la web?</span>
            <select
              className="form-control input"
              value={aparecerTodos}
              onChange={({ target: { value } }) => {
                setAparecerTodos(value);
              }}
            >
              <option value="">Seleccione un valor</option>
              <option value={0}>No</option>
              <option value={1}>Si</option>
            </select>
          </div>
        </div>
        <div className="form-row mt-2">
          {/* <div className="col-6">
            <small>Subtipo</small>
            <select
              className="form-control input"
              value={subtype}
              onChange={({ target: { value } }) => {
                setSubtype(value);

                if (value == "ninguno") cleanSubtypeDetails();
              }}
            >
              <option value="ninguno">No aplica</option>
              <option value="direccion">Dirección</option>
              <option value="empresas">Empresas</option>
              <option value="direccion_empresas">Dirección, Empresas</option>
              <option value="gerente">Gerente</option>
              <option value="investigador_invitado">
                Investigador invitado
              </option>
              <option value="unidad_asociada">Unidad asociada</option>
              <option value="otros">Otros</option>
            </select>
          </div>

          {subtype !== "ninguno" && (
            <div className="col-6">
              <small>Detalle subtipo Español</small>
              <input
                type="text"
                className="form-control"
                // placeholder="Categoría Inglés"
                value={subtypeDetailsEs}
                onChange={({ target: { value } }) => {
                  setSubtypeDetailsEs(value);
                }}
              />
            </div>
          )}
          {subtype !== "ninguno" && (
            <div className="col-6">
              <small>Detalle subtipo Ingles</small>
              <input
                type="text"
                className="form-control"
                // placeholder="Categoría Inglés"
                value={subtypeDetailsEn}
                onChange={({ target: { value } }) => {
                  setSubtypeDetailsEn(value);
                }}
              />
            </div>
          )}
          {subtype !== "ninguno" && (
            <div className="col-6">
              <small>Detalle subtipo Valenciano</small>
              <input
                type="text"
                className="form-control"
                // placeholder="Categoría Inglés"
                value={subtypeDetailsVa}
                onChange={({ target: { value } }) => {
                  setSubtypeDetailsVa(value);
                }}
              />
            </div>
          )} */}

          {/* <div className="col">
            <span>Cva público?</span>
            <select
              className="form-control input"
              value={isCvaPublic}
              onChange={({ target: { value } }) => {
                setIsCvaPublic(value);
              }}
            >
              <option value={0}>Cva oculto</option>
              <option value={1}>Cva público</option>
            </select>
          </div> */}
        </div>
        <div className="form-row mt-4">
          {!isCreate ? (
            <div className=" col">
              <span>Cv </span>
              <CvaUploader handleFile={setCv} cv={cv} />
            </div>
          ) : (
            <div className="col">
              <span>Cv </span>
              <CvaUploader handleFile={setCv} cv={cv} />
            </div>
          )}
        </div>
        <div className="form-row">
          <div className="col">
            <small>Fecha de nacimiento</small>
            <DatePicker
              className="form-control input"
              placeholderText="*Fecha"
              selected={fechaNacimiento}
              onChange={(fechaNacimiento: any) =>
                setFechaNacimiento(fechaNacimiento)
              }
              dateFormat="dd MMMM, yyyy"
              isClearable
              locale="es"
              dropdownMode="select"
              showMonthDropdown
              showYearDropdown
              adjustDateOnChange
            />
          </div>
          <div className="col">
            <small>Lugar de nacimiento</small>
            <input
              type="text"
              className="form-control"
              placeholder="Lugar de nacimiento"
              value={lugarNacimiento ? lugarNacimiento : ""}
              onChange={({ target: { value } }) => {
                setLugarNacimiento(value);
              }}
            />
          </div>
          <div className="col">
            <small>Número SS</small>
            <input
              type="text"
              className="form-control"
              placeholder="Número SS"
              value={numeroSeguroSocial ? numeroSeguroSocial : ""}
              onChange={({ target: { value } }) => {
                setNumeroSeguroSocial(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Tipo documento</small>
            <input
              type="text"
              className="form-control"
              placeholder="Tipo documento"
              value={tipoDocumento ? tipoDocumento : ""}
              onChange={({ target: { value } }) => {
                setTipoDocumento(value);
              }}
            />
          </div>
          <div className="col">
            <small>Documento de identidad</small>
            <input
              type="text"
              className="form-control"
              placeholder="Documento de identidad"
              value={documentoDeIdentidad ? documentoDeIdentidad : ""}
              onChange={({ target: { value } }) => {
                setDocumentoDeIdentidad(value);
              }}
            />
          </div>
          <div className="form-row">
            {!isCreate ? (
              <div className=" col">
                <span>Pdf Documento </span>
                <ArchiveUploader
                  handleFile={setArchivoDocumento}
                  archive={archivoDocumento}
                />
              </div>
            ) : (
              <div className="col">
                <span>Pdf Documento </span>
                <ArchiveUploader
                  handleFile={setArchivoDocumento}
                  archive={archivoDocumento}
                />
              </div>
            )}
          </div>
        </div>
        <div className="form-row">
          <div className="col">
            <small>Dirección postal personal</small>
            <input
              type="text"
              className="form-control"
              placeholder="Dirección postal personal"
              value={direccionPostalPersonal ? direccionPostalPersonal : ""}
              onChange={({ target: { value } }) => {
                setDireccionPostalPersonal(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-3">
          <h5>Enlaces personales</h5>
        </div>

        <div className="form-row mt-3"></div>
        <div className="form-row mt-3">
          <div className="col">
            <small>LinkedIn</small>
            <input
              type="text"
              className="form-control"
              placeholder="Ej:https://www.linkedin.com/perfil"
              value={linkedIn ? linkedIn : ""}
              onChange={({ target: { value } }) => {
                setLinkedIn(value);
              }}
            />
          </div>
          <div className="col">
            <small>X</small>
            <input
              type="text"
              className="form-control"
              placeholder="Ej:https://x.com/perfil"
              value={twitter ? twitter : ""}
              onChange={({ target: { value } }) => {
                setTwitter(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-3">
          <div className="col">
            <small>Facebook</small>
            <input
              type="text"
              className="form-control"
              placeholder="Ej:https://www.facebook.com/perfil"
              value={facebook ? facebook : ""}
              onChange={({ target: { value } }) => {
                setFacebook(value);
              }}
            />
          </div>
          <div className="col">
            <small>Orcid</small>
            <input
              type="text"
              className="form-control"
              placeholder="Solo el código Orcid   "
              value={orcid ? orcid : ""}
              onChange={({ target: { value } }) => {
                setOrcid(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-3">
          <div className="col">
            <small>Skype</small>
            <input
              type="text"
              className="form-control"
              placeholder="Usuario skype"
              value={skype ? skype : ""}
              onChange={({ target: { value } }) => {
                setSkype(value);
              }}
            />
          </div>
          <div className="col">
            <small>BlueSky</small>
            <input
              type="text"
              className="form-control"
              placeholder="Ej: https://bsky.app/profile/profile"
              value={blueSky ? blueSky : ""}
              onChange={({ target: { value } }) => {
                setBlueSky(value);
              }}
            />
          </div>
        </div>

        <div className="form-row mt-3">
          <h5>Biografía</h5>
        </div>
        {(isCreate || allowedEdit) && (
          <div className="form-row mt-2">
            <div className="col">
              <small>Biografía en español</small>
              <CKEditor
                initData={bioEs}
                config={editorConfig}
                onChange={({ editor }: { editor: any }) =>
                  setBioEs(editor.getData())
                }
              />
            </div>
            <div className="col">
              <small>Biografía en inglés</small>
              <CKEditor
                initData={bioEn && bioEn}
                config={editorConfig}
                onChange={({ editor }: { editor: any }) =>
                  setBioEn(editor.getData())
                }
              />
            </div>
            <div className="col">
              <small>Biografía en valenciano</small>
              <CKEditor
                initData={bioVa}
                config={editorConfig}
                onChange={({ editor }: { editor: any }) =>
                  setBioVa(editor.getData())
                }
              />
            </div>
          </div>
        )}
        <div className="form-row mt-3">
          <div className="col">
            <small>Título Español</small>
            <textarea
              className="form-control textarea"
              // placeholder="Palabras clave español (separado por comas)"
              rows={3}
              value={tituloEs ? tituloEs : ""}
              onChange={({ target: { value } }) => {
                setTituloEs(value);
              }}
            />
          </div>
          <div className="col">
            <small>Título Inglés</small>
            <textarea
              className="form-control textarea"
              // placeholder="Palabras clave inglés (separado por comas)"
              rows={3}
              value={tituloEn ? tituloEn : ""}
              onChange={({ target: { value } }) => {
                setTituloEn(value);
              }}
            />
          </div>
          <div className="col">
            <small>Título Valenciano</small>
            <textarea
              className="form-control textarea"
              // placeholder="Palabras clave español (separado por comas)"
              rows={3}
              value={tituloVa ? tituloVa : ""}
              onChange={({ target: { value } }) => {
                setTituloVa(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-3">
          <h5>Recursos Humanos</h5>
        </div>

        <label>Contratos</label>
        <div>
          {contratos?.map((contrato, index) => (
            <div key={index} className="d-flex align-items-center">
              <div className="col ">
                <input
                  type="text"
                  className="form-control"
                  placeholder="nombre"
                  value={contrato.name ? contrato.name : ""}
                  onChange={({ target: { value } }) => {
                    setContratos((prevContratos) =>
                      prevContratos.map((contrato, i) =>
                        i === index ? { ...contrato, name: value } : contrato
                      )
                    );
                  }}
                />
              </div>
              <div className="col mt-4">
                <ArchiveUploader
                  handleFile={(file) => {
                    setContratos((prevContratos) => {
                      // Clonamos el array de contratos para evitar modificarlo directamente
                      const updatedContratos = Array.isArray(prevContratos)
                        ? [...prevContratos]
                        : [];

                      // Verificamos que el índice existe antes de actualizar
                      if (updatedContratos[index]) {
                        updatedContratos[index] = {
                          ...updatedContratos[index],
                          archivo: file, // Asignamos el archivo correcto
                        };
                      } else {
                        console.error("Índice fuera de rango:", index);
                      }

                      return updatedContratos;
                    });
                  }}
                  archive={contrato.archivo}
                />
              </div>
              <a
                href={baseURL + contrato.archivo}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver archivo
              </a>

              <button
                className="btn btn-danger ml-2"
                onClick={() => handleRemoveContrato(index)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>
          ))}
          <button
            className="btn btn-primary mt-2 ml-3"
            onClick={handleAddContrato}
          >
            Añadir contrato
          </button>
        </div>
      </div>

      <label className="ml-3 mt-5">Títulos</label>
      <div>
        {titulos?.map((titulo, index) => (
          <div key={index} className="d-flex align-items-center mb-2 ml-3">
            <div className="col">
              <input
                type="text"
                className="form-control"
                placeholder="nombre"
                value={titulo.name ? titulo.name : ""}
                onChange={({ target: { value } }) => {
                  setTitulos((prevTitulos) =>
                    prevTitulos.map((titulo, i) =>
                      i === index ? { ...titulo, name: value } : titulo
                    )
                  );
                }}
              />
            </div>
            <div className="col">
              <ArchiveUploader
                handleFile={(file) => {
                  setTitulos((prevTitulos) => {
                    // Clonamos el array de contratos para evitar modificarlo directamente
                    const updatedTitulos = Array.isArray(prevTitulos)
                      ? [...prevTitulos]
                      : [];

                    // Verificamos que el índice existe antes de actualizar
                    if (updatedTitulos[index]) {
                      updatedTitulos[index] = {
                        ...updatedTitulos[index],
                        archivo: file, // Asignamos el archivo correcto
                      };
                    } else {
                      console.error("Índice fuera de rango:", index);
                    }

                    return updatedTitulos;
                  });
                }}
                archive={titulo.archivo}
              />
            </div>

            {titulo.archivo && (
              <button>
                {" "}
                <a
                  href={baseURL + titulo.archivo}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ver archivo
                </a>
              </button>
            )}

            <button
              className="btn btn-danger ml-2"
              onClick={() => handleRemoveTitulo(index)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        ))}
        <button className="btn btn-primary mt-2 ml-4" onClick={handleAddTitulo}>
          Añadir título
        </button>
      </div>
      <div className="form-row mt-4">
        {isMyProfile && (
          <div className="col">
            <button className="baseBtn" onClick={() => setIsModalOpen(true)}>
              Cambiar Contraseña
            </button>
          </div>
        )}
      </div>

      {!isCreate && isMyProfile && (
        <div className="row mt-4">
          <div className="col-12 ">
            <div className="col d-flex justify-content-between">
              <h5>Publicaciones seleccionadas</h5>
            </div>
            <table className="table table-hover mt-4">
              <tbody>
                {selectedPublications?.map(
                  (
                    { id, title, authors, date, selected }: IPublication,
                    index
                  ) => (
                    <tr key={index} className="pointer">
                      <td>
                        <div className="d-flex justify-content-between">
                          <h6>{parse(title)}</h6>
                          <img
                            style={{ width: "2%" }}
                            src={changeIcon(selected)}
                            alt=""
                            onClick={() => changeSelected(index)}
                          />
                        </div>

                        <p>
                          {authors} {","}{" "}
                          {moment(date).locale("es").format("YYYY")}
                        </p>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
            {isLoading && isMyProfile && (
              <div className="d-flex justify-content-center">
                <div className="spinner-border mt-5" role="status" />
              </div>
            )}

            {!selectedPublications.length && !isLoading && (
              <div className="d-flex justify-content-center mb-3">
                <h5>-No hay publicaciones seleccionadas-</h5>
              </div>
            )}
          </div>
        </div>
      )}
      {!isCreate && isMyProfile && (
        <div className="row mt-4">
          <Form.Group as={Col}>
            <InputGroup className="shadow">
              <InputGroup.Prepend>
                <InputGroup.Text className="inputGroup ">
                  <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                placeholder="Buscar..."
                className="form-control"
                onChange={({ target: { value } }) => searchBar(value)}
              />
            </InputGroup>
          </Form.Group>
        </div>
      )}
      {!isCreate && isMyProfile && (
        <div className="row mt-3">
          <div className="col-12 ">
            <h5>Publicaciones</h5>
            <table className="table table-hover">
              <tbody>
                {displayPublications?.map(
                  (
                    { id, title, authors, date, selected }: IPublication,
                    index
                  ) => (
                    <tr key={index} className="pointer">
                      <td>
                        <div className="d-flex justify-content-between">
                          <h6>{parse(title)}</h6>
                          <img
                            style={{ width: "2%" }}
                            src={changeIcon(selected)}
                            alt=""
                            onClick={() => changeNotSelected(index)}
                          />
                        </div>
                        <p>
                          {authors} {","}{" "}
                          {moment(date).locale("es").format("YYYY")}
                        </p>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
            {isLoading && (
              <div className="d-flex justify-content-center">
                <div className="spinner-border mt-5" role="status" />
              </div>
            )}

            {!displayPublications.length && !isLoading && (
              <div className="d-flex justify-content-center mb-3">
                <h5>-No hay publicaciones-</h5>
              </div>
            )}
          </div>
        </div>
      )}

      {/* //Modal para cambiar contraseña */}
      <Modal centered show={isModalOpen} onHide={() => setIsModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Actualiza tu contraseña</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center text-danger">
                <span>{passMessage}</span>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <input
                  className="form-control"
                  type="password"
                  placeholder="*Contraseña Actual"
                  value={oldPassword}
                  onChange={({ target: { value } }) => {
                    setOldPassword(value);
                  }}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <input
                  className="form-control"
                  type="password"
                  placeholder="*Nueva Contraseña"
                  value={newPassword}
                  onChange={({ target: { value } }) => {
                    setNewPassword(value);
                  }}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <input
                  className="form-control"
                  type="password"
                  placeholder="*Repetir Contraseña"
                  value={repeatNewPass}
                  onChange={({ target: { value } }) => {
                    setRepeatNewPass(value);
                    checkNewPassword(value);
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
            Cerrar
          </Button>
          <Button
            variant="primary"
            disabled={!isPassChecked}
            onClick={handleSubmitNewPassword}
          >
            Guardar Cambio
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
